
<div #showVideModalPopUp class="modal" data-toggle="modal" data-backdrop="false" id="showVideModalPopUp" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content modal-content-container">
      @if (isVideoLive) {
        <div id="myDiv" style="height: inherit;">
          <div class="video-screen-main" style="height: inherit;">
            <app-video-calls [dataResponse]="videoCallTrack">
            </app-video-calls>
          </div>
        </div>
      }
    </div>
  </div>
</div>
<div class="pip-container" #pipContainer (mousedown)="startDrag($event)">
  <div class="pip-player" id="pipPlayer" #pipPlayer>
    <div class="row2">
      <div class="container1">
        <div class="col3 button-group">
          <button id="videoButton" class="button hidden-button" (click)="toggleRemotePictureInPicture()" title="Back to tab">
            <span class="material-icons material-symbols-outlined" style="font-size: 30px;">
              fullscreen
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
